import { render, staticRenderFns } from "./PictogramImagesList.vue?vue&type=template&id=54361260&"
import script from "./PictogramImagesList.vue?vue&type=script&lang=js&"
export * from "./PictogramImagesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports